import { CustomISBN, CustomISBNSearchState } from '../interfaces/custom-isbn.interface';
import { StoreState } from '../../../store/store.interface';

/*----- SELECTORS ------*/
export const getCustomISBN = (state: StoreState): CustomISBN | undefined => {
  const customISBNSearch: CustomISBNSearchState = state.customISBNSearchState;
  if (customISBNSearch?.data?.customIsbn) {
    return customISBNSearch.data;
  }
  return;
}
